import PropTypes from 'prop-types';
import './StatusPill.css';

const MEMBER_LABELS = {
  active: 'Activo',
  pending: 'Pendiente',
};

const JOB_LABELS = {
  pending: 'Pendiente',
  processing: 'Procesando',
  success: 'Éxito',
  warning: 'Advertencia',
  error: 'Error',
};

export function StatusPill({ kind, value, label }) {
  if (kind === 'member') {
    const cls = value === 'active' ? 'active' : 'pending';
    const text = label || MEMBER_LABELS[value] || value;
    return (
      <span className={`status-dot-pill ${cls}`}>
        <span className="d" />
        {text}
      </span>
    );
  }

  if (kind === 'job') {
    const cls = value || 'pending';
    const text = label || JOB_LABELS[value] || value;
    return (
      <span className={`job-status ${cls}`}>
        <span className="d" />
        {text}
      </span>
    );
  }

  return null;
}

StatusPill.propTypes = {
  kind: PropTypes.oneOf(['member', 'job']).isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default StatusPill;
